/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import * as reducers from './../reducers';
import { selectJob } from './../actions';
import { chart } from './../helpers';

// With point options enabled:
// Using the Case Metric point options will color points the same as hit chart
// else will highlight points if value has delta from previous point
export const getPointOptions = (state, ownProps, data) => {
  if (ownProps.disablePointOptions) {
    return undefined;
  }

  const pointOptions = ownProps.overrideCaseMetricsPointOptions ?
    chart.multiLineDataToFormattedPointOptions(data, ownProps.seriesColors) :
    chart.caseMetricsPointColorsToOptions(
      reducers.getCaseMetricsHitChartPointColors(state),
      ownProps.seriesColors
    );
  return pointOptions;
};

export const mapStateToProps = (state, ownProps) => {
  const metrics = reducers.getCaseMetricsScanMetrics(state);
  const pointRadius = metrics ? 0 : 4;
  const highlights = reducers.getMetricsPageHighlights(state);

  const data = ownProps.getMetricFuncPerDataSet.map(func =>
    metrics.map(m => func(m)));

  const props = {
    data,
    series: ownProps.seriesLabels.map((label, index) => {
      return {
        backgroundColor: ownProps.seriesColors[index],
        borderColor: ownProps.seriesColors[index],
        label,
        pointRadius
      };
    }),
    pointOptions: getPointOptions(state, ownProps, data),
    labels: metrics.map(m => m ? m.jobNumber : undefined),
    lines: highlights,
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => chart.metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
  return props;
};

const CaseMetricsGenericMetricChartContainer = connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);

CaseMetricsGenericMetricChartContainer.propTypes = {
  getMetricFuncPerDataSet: (props, propName, componentName) => {
    const funcArr = props.getMetricFuncPerDataSet;
    if (funcArr.length === 0) {
      return new Error(
        `Invalid prop: ${propName} supplied to ${componentName} cannot be empty`);
    }
  },
  overrideCaseMetricsPointOptions: PropTypes.bool,
  disablePointOptions: PropTypes.bool,
  seriesColors: (props, propName, componentName) => {
    const funcArr = props.getMetricFuncPerDataSet;
    const colArr = props.seriesColors;
    if (funcArr.length !== colArr.length) {
      return new Error(
        `Invalid prop: ${propName} supplied to ${componentName} must have length
          matching length of props.getMetricFuncPerDataSet`
      );
    }
  },
  seriesLabels: (props, propName, componentName) => {
    const funcArr = props.getMetricFuncPerDataSet;
    const labelArr = props.seriesLabels;
    if (funcArr.length !== labelArr.length) {
      return new Error(
        `Invalid prop: ${propName} supplied to ${componentName} must have length
          matching length of props.getMetricFuncPerDataSet`
      );
    }
  },
};

export default CaseMetricsGenericMetricChartContainer;


// WEBPACK FOOTER //
// src/Containers/CaseMetricsGenericMetricChartContainer.jsx